module.exports = __webpack_public_path__ + "static/media/nima9.326ccc27.png";